module.exports = __webpack_public_path__ + "img/no_order.e51a7af0.svg";